const stations = [
  {
    coordinate: { latitude: -15.64163611, longitude: -71.60173056 },
    title: 'Chivay',
    key: 'chivay',
  },
  {
    coordinate: { latitude: -15.60998889, longitude: -71.80654444 },
    title: 'Madrigal',
    key: 'madrigal',
  },
  {
    coordinate: { latitude: -15.622594, longitude: -71.974086 },
    title: 'Cabanaconde',
    key: 'cabanaconde',
  },
];

export default function getStations() {
  return stations;
}
